import React, { useMemo } from "react";
import ArchitectureDiagram from "../shared/ArchitectureDiagram";

export default function ArchitectureTab({ project }) {
  const items = useMemo(() => project.architecture || [], [project]);

  if (!items.length) {
    return (
      <div className="project__card project__cardFull">
        <p className="project__empty">No architecture added yet.</p>
      </div>
    );
  }

  return (
    <div className="project__card project__cardFull">
      <h3 className="project__cardTitle">Architecture</h3>

      <div className="archList" aria-label="Architecture flows">
        {items.map((it) => (
          <article key={it.key || it.title} className="archList__item">
            <div className="archList__header">
              <h4 className="archList__title">{it.title}</h4>
              {it.description ? <p className="archList__desc">{it.description}</p> : null}
            </div>

            <div className="arch__canvas" aria-label={`${it.title} diagram`}>
              <ArchitectureDiagram spec={it.svg} />
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
